(function() {
    angular.module('emarket.main.post').controller('OfferManageDialogController', ['$mdDialog', 'post', function($mdDialog, post) {
        var vm = this;
        vm.post = post;

        vm.close = function() {
            $mdDialog.hide();
        };
        vm.accept = function(offer) {
            post.offers.forEach(function(offer) {
                offer.status = 'rejected';
            });
            offer.status = 'accepted';
            post.$save([ 'offers' ]);
        };
        vm.reject = function(offer) {
            offer.status = 'rejected';
            post.$save([ 'offers' ]);
        };
        // vm.order = function(element) {
        //   var order;
        //   if(element.status === 'accepted') {
        //     order =
        //   }
        // }
    }]);
}());
